module.exports = __webpack_public_path__ + "img/D201806_3.178bc336.jpg";